import { useEffect } from 'react';

export function useLCP(callback: (entry: PerformanceEntry) => void) {
  useEffect(() => {
    const observer = new PerformanceObserver((entryList) => {
      const entries = entryList.getEntries();
      const lcpEntry = entries[entries.length - 1];
      if (lcpEntry) {
        callback(lcpEntry);
      }
    });

    observer.observe({ type: 'largest-contentful-paint', buffered: true });

    return () => observer.disconnect();
  }, [callback]);
}
